const messages = {
  "Algolia.GlobalSearch.Heading": "搜索结果",
  "Algolia.GlobalSearch.TextField.Placeholder": "您想要搜索什么",
  "Algolia.GlobalSearch.SearchButton.Text": "搜索",
  "Algolia.GlobalSearch.EventType.Label": "页面类型",
  "Algolia.GlobalSearch.ItemsPerPage.Label": "每页数量",
  "Algolia.GlobalSearch.Meta.Text": "{count} 条结果",

  "Algolia.SearchPage.Heading": "海外交流项目查询",
  "Algolia.SearchPage.TextField.Placeholder": "通过关键字搜索项目",
  "Algolia.SearchPage.Filters.Label": "查询条件",
  "Algolia.SearchPage.ClearButton.Label": "清空所有",
  "Algolia.SearchPage.ProgramType.Label": "项目类型",
  "Algolia.SearchPage.DeliveryMethod.Label": "授课方式",
  "Algolia.SearchPage.HousingType.Label": "住宿类型",
  "Algolia.SearchPage.AcademicLevel.Label": "学术水平",
  "Algolia.SearchPage.UniversityName.Label": "大学名称",
  "Algolia.SearchPage.Select.Placeholder": "输入或选择",
  "Algolia.SearchPage.UniversityRanking.Label": "大学排名",
  "Algolia.SearchPage.AcademicDiscipline.Label": "学科",
  "Algolia.SearchPage.Regions.Label": "地区",
  "Algolia.SearchPage.SubregionsCities.Label": "国家地区和城市",
  "Algolia.SearchPage.LanguageOfInstruction.Label": "授课语言",
  "Algolia.SearchPage.languagePrerequisiteLevel.Label": "语言要求",
  "Algolia.SearchPage.GPARequirements.Label": "GPA要求",
  "Algolia.SearchPage.TermType.Label": "学期类型",
  "Algolia.SearchPage.ProgramFees.Label": "项目费用",
  "Algolia.SearchPage.SearchButton.Title": "搜索项目",
  "Algolia.SearchPage.ResultsMeta": '{count} 条项目',
  "Algolia.SearchPage.SortBy.Label": "排序",
  "Algolia.SearchPage.SortBy.Relevancy.option": "相关度",
  "Algolia.SearchPage.SortBy.Newest.option": "最新",
  "Algolia.SearchPage.CreditPrograms.Label": "仅显示学分项目",
  "Algolia.SearchPage.HousingType.Tooltip": "已有心仪的住宿类型吗？请按住宿类型查询项目",
  "Algolia.SearchPage.languagePrerequisiteLevel.Tooltip": "想寻找适合您语言水平的项目？请按语言水平查询项目",
  "Algolia.SearchPage.GPARequirements.Tooltip": "想寻找适合您学术成绩的项目？请按GPA水平查询项目",
  "Algolia.SearchPage.ProgramFees.Tooltip": "已有预算了吗？请在此根据费用查询。可多选以扩大搜索范围",

  "Pager.Current.MetaCurrent": "当前页",
  "Pager.First.MetaFirst": "首页",
  "Pager.Last.MetaLast": "末页",
  "Pager.Next.MetaTitle": "下一页",
  "Pager.Next.TextFull": "下一页",
  "Pager.Next.Text": "下一页",
  "Pager.Page.MetaPageNumber": "前往第 {page} 页",
  "Pager.Page.VisuallyHidden": "页",
  "Pager.Previous.MetaTitle": "上一页",
  "Pager.Previous.TextFull": "上一页",
  "Pager.Previous.Text": "上一页",

  "ProgramCard.Label.None": "无",
  "ProgramCard.EstimatedCost.Label": "预计费用",
  "ProgramCard.CTA.Label": "项目详情",
  "ProgramCard.GPARequirements.Label": "GPA要求",
  "ProgramCard.LanguageOfInstruction.Label": "授课语言",
  "ProgramCard.LanguageRequirements.Label": "语言要求",
  "ProgramCard.Status.Label": "项目已暂停",

  "ProgramQuickView.Length.Label": "时长",
  "ProgramQuickView.Options.Label": "授课方式",
  "ProgramQuickView.ReadMore.CTA": "了解更多",
  "ProgramQuickView.ProgramDetails.CTA": "查看项目详情",
  "ProgramQuickView.ApplyNow.CTA": "立即申请",
  "ProgramQuickView.AtGlance.Label": "信息一览",
  "ProgramQuickView.LanguageInstruction.Label": "授课语言",
  "ProgramQuickView.LanguageRequirements.Label": "语言要求",
  "ProgramQuickView.languagePrerequisiteLevel.Label": "语言要求",
  "ProgramQuickView.GPA.Label": "GPA要求",
  "ProgramQuickView.AcademicLevel.Label": "学术水平",
  "ProgramQuickView.Credits.Label": "学分",
  "ProgramQuickView.AcademicStrengths.Label": "学术强项",
  "ProgramQuickView.Housing.Label": "住宿",
  "ProgramQuickView.Internship.Label": "兼职实习（可选)",
  "ProgramQuickView.Visa.Label": "需要签证",

  "ProgramSelector.BlockTitle": "寻找最适合你的项目!",
  "ProgramSelector.BlockDescription": "通过目的地国家、海外大学或海外交流项目类型寻找理想的项目",
  "ProgramSelector.BlockLink": "或浏览所有海外交流项目",
  "ProgramSelector.Destinations.BlockDescription": "选择你最感兴趣的地区",
  "ProgramSelector.Destinations.BlockQuestion": "你想去哪里学习",
  "ProgramSelector.Destinations.AllDestinations.Label": "所有目的地",
  "ProgramSelector.Destinations.Destinations.Label": "目的地国家",
  "ProgramSelector.Universities.BlockDescription": "选择所有你感兴趣的海外大学",
  "ProgramSelector.Universities.BlockQuestion": "你想去哪所海外大学学习",
  "ProgramSelector.Universities.Universities.Label": "海外大学",
  "ProgramSelector.TypeOfStudy.TypeOfStudy.Label": "项目类型",
  "ProgramSelector.TypeOfStudy.BlockDescription": "选择所有你感兴趣的学习类型",
  "ProgramSelector.TypeOfStudy.BlockQuestion": "你喜欢什么类型的项目",
  "ProgramSelector.SeePrograms.Label": "查看我的项目",
  "ProgramSelector.BrowsePrograms.Label": "或浏览所有海外交流项目",

  "Algolia.SidebarFilters.SelectOrRadios.FirstOption": "全部",
  "Algolia.SearchPage.GPARequirements.Options.None": "无",
}

export default messages;
